import { API_END_POINTS } from '@constants/global-constants';
import { axiosInstance } from './public-service-instance';

export const getAccessTokenFromMarketPlace = async (payload: any) => {
    return await axiosInstance.post(API_END_POINTS.AUTH_MARKETPLACE_ACCESS, payload);
};